import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Location", href: "/location" },
];

const services = [
  "Newborn Photography",
  "Luxury Weddings",
  "Maternity Sessions",
  "Senior Portraits",
  "Quinceañera & Sweet 16",
  "Milestones & Family",
];

export default function SiteFooter() {
  return (
    <footer className="bg-pk-dark text-pk-cream">
      {/* Top Accent Line */}
      <div className="h-px bg-gradient-to-r from-transparent via-pk-gold/50 to-transparent" />

      {/* Upper Footer */}
      <div className="max-w-screen-xl mx-auto px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand — wider */}
          <div className="md:col-span-5">
            <img
              src="https://images-pw.pixieset.com/profile/632184/8e2e397ed4499187d962a6bd1d1c7a5bdb31a2144ecd3aa53b6892fc200e0365.png"
              alt="Precious Keepsakes Photography"
              className="h-11 w-auto object-contain mb-7 brightness-0 invert opacity-85"
            />
            <p className="font-sans text-sm text-pk-cream/55 leading-7 max-w-sm">
              Precious Keepsakes is a fine art portrait and wedding photography studio based in San Antonio, Texas. Creating heirloom imagery that outlasts generations.
            </p>

            {/* Photo strip */}
            <div className="mt-8 flex gap-3">
              {[
                { src: "https://images-pw.pixieset.com/site/BAJyQr/y5V5JJ/002-20240304-4252fe92-1500.jpg", alt: "Newborn" },
                { src: "https://images-pw.pixieset.com/site/BAJyQr/wdadAo/B1B-328cb125-1500.jpg", alt: "Wedding" },
                { src: "https://images-pw.pixieset.com/site/BAJyQr/0PjQvm/18-430f468f-1500.jpg", alt: "Milestones" },
              ].map((img) => (
                <div key={img.alt} className="w-20 h-20 rounded-sm overflow-hidden">
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover object-top opacity-60 hover:opacity-100 transition-opacity duration-300 cursor-pointer"
                  />
                </div>
              ))}
            </div>

            {/* Contact */}
            <div className="mt-8 space-y-3">
              <a href="tel:2108154698" className="flex items-center gap-3 group cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-pk-gold text-sm" />
                </div>
                <span className="font-sans text-sm text-pk-cream/60 group-hover:text-pk-gold transition-colors duration-300">
                  210-815-4698
                </span>
              </a>
              <a href="mailto:stephanie@precious-keepsakes.com" className="flex items-center gap-3 group cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-pk-gold text-sm" />
                </div>
                <span className="font-sans text-sm text-pk-cream/60 group-hover:text-pk-gold transition-colors duration-300 break-all">
                  stephanie@precious-keepsakes.com
                </span>
              </a>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-pk-gold text-sm" />
                </div>
                <span className="font-sans text-sm text-pk-cream/60">San Antonio, Texas</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <h4 className="font-sans text-xs tracking-widest3 uppercase text-pk-gold mb-7">Pages</h4>
            <ul className="space-y-3">
              {footerLinks.map(({ label, href }) => (
                <li key={label}>
                  <Link
                    to={href}
                    className="font-sans text-sm text-pk-cream/55 hover:text-pk-gold transition-colors duration-300 cursor-pointer flex items-center gap-2 group"
                  >
                    <span className="w-0 group-hover:w-3 h-px bg-pk-gold transition-all duration-300" />
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="font-sans text-xs tracking-widest3 uppercase text-pk-gold mb-7">Services</h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <Link
                    to="/services"
                    className="font-sans text-sm text-pk-cream/55 hover:text-pk-gold transition-colors duration-300 cursor-pointer flex items-center gap-2 group"
                  >
                    <span className="w-0 group-hover:w-3 h-px bg-pk-gold transition-all duration-300" />
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Column */}
          <div className="md:col-span-2">
            <h4 className="font-sans text-xs tracking-widest3 uppercase text-pk-gold mb-7">Ready?</h4>
            <p className="font-sans text-xs text-pk-cream/50 leading-6 mb-6">
              Begin with a free personal consultation.
            </p>
            <Link
              to="/services"
              className="block bg-pk-gold text-white font-sans text-xs tracking-widest2 uppercase px-5 py-3 rounded-sm text-center hover:bg-white hover:text-pk-charcoal transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Book a Session
            </Link>
            <a
              href="tel:2108154698"
              className="mt-3 block border border-white/10 text-pk-cream/50 font-sans text-xs tracking-widest2 uppercase px-5 py-3 rounded-sm text-center hover:border-pk-gold hover:text-pk-gold transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Call Now
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8 px-8 py-6">
        <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-sans text-xs text-pk-cream/30">
            &copy; {new Date().getFullYear()} Precious Keepsakes Photography. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <p className="font-sans text-xs text-pk-cream/30">
              San Antonio, Texas
            </p>
            <span className="text-pk-cream/15">·</span>
            <p className="font-sans text-xs text-pk-cream/30">
              Fine Art Wedding &amp; Portraiture
            </p>
            <span className="text-pk-cream/15">·</span>
            <p className="font-sans text-xs text-pk-cream/30">
              Est. 2009
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
